import { createAction } from 'typesafe-actions';

import { SET_SELECTED_DAY, START_SELECT_DAY } from './constants';
import { RealtimeState } from './index';

export const setSelectedDay = createAction(
  SET_SELECTED_DAY,
  (payload: RealtimeState['selectedDay']) => payload,
)();

export const startSelectDay = createAction(
  START_SELECT_DAY,
  (payload: { selectedDay: RealtimeState['selectedDay'] }) => payload,
)();
